import { defineStore } from 'pinia'
import SensorNormalizationState, { SensorNormalizationStateType } from './state'
import { SensorNormalizationActions, SensorNormalizationActionsType } from './actions'
import { SensorNormalizationGetters } from './getters'

export const useSensorNormalizationStore = defineStore<
  'sensorNormalization',
  SensorNormalizationStateType,
  typeof SensorNormalizationGetters,
  SensorNormalizationActionsType
>('sensorNormalization', {
  state: SensorNormalizationState,
  actions: SensorNormalizationActions,
  getters: SensorNormalizationGetters,
})
